import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { store } from './store'
import { injectStore } from './services/api'
import { ToastProvider } from './contexts/ToastContext'
import { ConfirmProvider } from './components/common/ConfirmDialog'
import { PusherProvider } from './contexts/PusherContext'
import { I18nProvider } from './i18n'
import './index.css'

// Inject store into api to avoid circular dependency
injectStore(store)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <I18nProvider>
          <ToastProvider>
            <ConfirmProvider>
              <PusherProvider>
                <App />
              </PusherProvider>
            </ConfirmProvider>
          </ToastProvider>
        </I18nProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)

// Register Service Worker for PWA support
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW registration failed silently
    })
  })
}
